import { useAuthSiteStore } from "@/stores/AuthStore"
import { useCartStore } from "@/stores/CartStore"

export const AuthGuard = (to, from, next) => {
  const authSiteStore = useAuthSiteStore()
  const cartStore = useCartStore()

  if (to.meta.requiresAuth && !authSiteStore.isAuthenticated) {
    next('/login')
  } else if (to.path === '/checkout' && cartStore.TotalItensInCart === 0) {
    next('/')
  } else {
    next()
  }

}

export const LoginGuard = (to, from, next) => {
  const authSiteStore = useAuthSiteStore()

  if (!authSiteStore.isAuthenticated) {
    next()
  } else {
    next('/')
  }
}

export const ForgotPasswordGuard = (to, from, next) => {
  const authSiteStore = useAuthSiteStore()

  if (authSiteStore.isAuthenticated) {
    next('/')
  } else if (to.path === '/resetar-senha' && (!to.query.token || to.query.token.trim() === '')) {
   next('/login')
  } else{
    next()
  }

}

// export const VerifyLoginAffiliate = (to, from, next) => {
//   const authSiteStore = useAuthSiteStore()

//   if (authSiteStore.isAuthenticated && authSiteStore.user.isAffiliate) {
//     next('/afiliado')
//   } else if (!authSiteStore.isAuthenticated) {
//     next('/afiliado/login')
//   } else {
//     next()
//   }
// }
